import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import BaseDialog from 'components/BaseDialog';
import scmp, { FlexColContainer, FlexRowContainer } from 'components/StyledComp';
import CustomButton from 'components/CustomButton';

const propTypes = {
  onConfirmClick: PropTypes.func,
};

@autobind
class AskClaimRefNumberDialog extends BaseDialog {
  constructor(props) {
    super(props);

    this.state = {
      claimRefNumber: '',
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.isVisible && !prevProps.isVisible) {
      this.setState({
        claimRefNumber: '',
      });
    }
  }

  onConfirmClick() {
    this.props.onConfirmClick(this.state.claimRefNumber);
    this.dismiss();
  }

  onCancelClick() {
    this.dismiss();
  }

  render() {
    const { isVisible, ...layoutProps } = this.props;
    const { claimRefNumber } = this.state;

    return (
      <scmp.AntdModal
        {...layoutProps}
        // maxWidth="700px"
        style={{ top: 20 }}
        // bodyStyle={{ padding: '0 0' }}
        visible={isVisible}
        centered
        maskClosable
        footer={null}
        afterClose={this.onModalHide}
        onOk={this.onOkClick}
        onCancel={this.onOkClick}
      >
        <FlexColContainer
          width="match_parent"
          height="wrap_content"
          padding="4px 4px"
          alignItems="center"
        >
          <scmp.Span
            width="wrap_content"
            height="wrap_content"
            margin="0 0 16px 0"
            color="textPrimaryDark"
            fontSize="16px"
          >
            Please enter Claim Reference Number.
          </scmp.Span>

          <scmp.AntdInput
            width="match_parent"
            height="wrap_content"
            margin="0 0 20px 0"
            color="textPrimaryDark"
            size="small"
            placeholder=""
            value={claimRefNumber}
            onChange={e => this.setState({ claimRefNumber: e.target.value })}
          />

          <FlexRowContainer
            width="wrap_content"
            height="wrap_content"
          >
            <CustomButton
              width="wrap_content"
              height="32px"
              margin="0 20px 0 0"
              backgroundColor="blue_steel"
              fontSize="14px"
              type="primary"
              onClick={this.onConfirmClick}
            >
              CONFIRM
            </CustomButton>

            <scmp.AntdButton
              width="wrap_content"
              height="32px"
              fontSize="14px"
              type="default"
              onClick={this.onCancelClick}
            >
              CANCEL
            </scmp.AntdButton>
          </FlexRowContainer>
        </FlexColContainer>
      </scmp.AntdModal>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
AskClaimRefNumberDialog.propTypes = propTypes;

export default AskClaimRefNumberDialog;
